import React from 'react';

function CrmContactDummyItem({ dummyItem }) {
  return (
    <tr className='crm-table-item'>
      <td style={{ height: dummyItem?.itemHeight }}></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
  );
}

export default CrmContactDummyItem;
